type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconArrowBack({
    color = 'black',
    width = 22,
    height = 22,
}: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <path d="M8.72 12L16.07 4.65C16.32 4.4 16.45 4.1 16.44 3.76C16.43 3.42 16.3 3.12 16.05 2.88C15.8 2.62 15.5 2.5 15.16 2.5C14.82 2.5 14.53 2.62 14.28 2.88L6.6 10.57C6.4 10.78 6.25 11 6.15 11.25C6.05 11.5 6 11.75 6 12C6 12.25 6.05 12.5 6.15 12.75C6.25 13 6.4 13.22 6.6 13.43L14.3 21.12C14.55 21.38 14.84 21.5 15.18 21.49C15.51 21.48 15.8 21.35 16.05 21.1C16.3 20.85 16.43 20.55 16.43 20.21C16.43 19.87 16.3 19.57 16.05 19.32L8.72 12Z" fill={color} />
        </svg>
    );
}
